module.exports = __webpack_public_path__ + "static/media/Template_36.23b61d4c.png";